import React from "react";
import { Button, Icon, Row, Col, Result } from "antd";
import { withParams } from "../../utils/url";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import {
  getDrugManagementStatus,
  getDoseCalculationActiveStatus,
} from "../../reducers/user/selectors";
import { connect } from "react-redux";
import get from "lodash/get";

const routes = require("../../routes.json");

const ResultsRandomizationComponent = (props) => {
  let title = props.i18n.t(
            "NamespaceResults:Randomization has been completed successfully. Please see details below!"
          );
  let status = "success";
  if (get(props, "new_randomization") === false){
    title = props.i18n.t(
            "NamespaceResults:DUPLICATE RANDOMIZATION. Please see details below!"
          );
    status = "warning";
  }
  // get(resultData, "new_randomization")
  return (
    <Row type="flex" align="middle" justify="center">
      <Col style={{ maxWidth: "600px" }}>
        <Result
          status={status}
          title={title}
          subTitle={
            <div>
              {props.i18n.t("Subject ID")}: {props.studyID}.
              <br />
              {props.i18n.t("Date and Time")}: {props.date}
              <br />
              {props.treatment_code && (
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      color: "#3f3f3f",
                    }}
                  >
                    {props.i18n.t("Treatment Code")}: {props.treatment_code}
                  </span>
                  <br />
                </div>
              )}
              {props.treatment_arm_name && (
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      color: "#666",
                    }}
                  >
                    {props.i18n.t("Treatment")}: {props.treatment_arm_name}
                  </span>
                  <br />
                </div>
              )}
              {props.bottle_no && (
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      color: "#666",
                    }}
                  >
                    {!!(props.drug_dosage && props.drug_dosage.administration_type === 'tablet') && (
                      <span>{props.i18n.t("Package #")}: {props.bottle_no}</span>
                    )}
                    {!!(props.drug_dosage && props.drug_dosage.administration_type !== 'tablet') && (
                      <span>
                        {props.i18n.t("Drug #")}: {props.bottle_no}
                      </span>
                    )}
                  </span>
                  <br />
                </div>
              )}

              {!!(props.drug_dosage && props.drug_dosage.bolus_dose) && (
                <div>
                  {props.i18n.t("Bolus dose")}:{" "}
                  {props.drug_dosage.bolus_dose.toFixed(1)} mg
                </div>
              )}
              {!!(props.drug_dosage && props.drug_dosage.infusion_dose) && (
                <div>
                  {props.i18n.t("Infusion dose")}:{" "}
                  {props.drug_dosage.infusion_dose.toFixed(1)} ml
                </div>
              )}
              {!!(
                props.drug_dosage && props.drug_dosage.dose_overview && props.drug_dosage.administration_type === 'tablet'
              ) && (
                <div>
                  {props.i18n.t("Tablet patient dose")}:{" "}
                  {props.drug_dosage.dose_overview}
                </div>
              )}
              {!!(
                props.drug_dosage && props.drug_dosage.drug_administration_instructions
              ) && (
                <div>
                  {props.i18n.t("Administration instructions")}:{" "}
                  {props.drug_dosage.drug_administration_instructions}
                </div>
              )}
              <br />
              <br />
              <p>
                <a href="/admin/randomization">
                  <Button>
                    <Icon type="arrow-left" />
                    {props.i18n.t(
                      "NamespaceResultsRandomization:Start new Randomization"
                    )}
                  </Button>
                </a>
              </p>
              <p>
                <Link
                  to={withParams(routes.admin.patientProfileSingle, {
                    subjectID: props.studyID,
                  })}
                >
                  <Button type="primary">
                    {props.i18n.t(
                      "NamespaceResultsRandomization:Go to Profile"
                    )}
                  </Button>
                </Link>
              </p>
              {props.isDrugManagementActive && (
                <p>
                  {props.i18n.t(
                    "NamespaceResultsRandomization:Please Note that if re-allocation needs to occur, follow the below instructions"
                  )}
                  :
                  <br />
                  {props.i18n.t(
                    "NamespaceResultsRandomization:Click “Randomization” menu, and select “Subject Randomization List”"
                  )}
                  <br />
                  {props.i18n.t(
                    "NamespaceResultsRandomization:Search by subject ID and select the subject."
                  )}
                  <br />
                  {props.i18n.t(
                    "NamespaceResultsRandomization:Expand “Drug Reallocation” Menu."
                  )}
                  <br />
                  {props.i18n.t(
                    "NamespaceResultsRandomization:Enter re-allocation comments and click “Reallocate”"
                  )}
                </p>
              )}
            </div>
          }
        >
          {/*<p>Date and Time: {props.date}</p>*/}
          {/*<Button type='primary' onClick={props.onBackClick}><Icon type="arrow-left" />Back</Button>*/}
        </Result>
        {/*<h5 className='headline-default'>Date and Time: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.date}</span></h5>*/}
        {/*<h6 className='headline-default' style={{ marginTop: '1rem', color: 'var(--primary-color)' }} onClick={props.onBackClick}><Icon type="arrow-left" style={{ marginRight: '0.5rem' }} />Back</h6>*/}
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => ({
  isDrugManagementActive: getDrugManagementStatus(state),
  doseCalculationActiveStatus: getDoseCalculationActiveStatus(state),
});

export const ResultsRandomization = connect(mapStateToProps)(
  withNamespaces()(ResultsRandomizationComponent)
);



// WEBPACK FOOTER //
// ./src/components/Results/ResultsRandomization.js